import { render, staticRenderFns } from "./DetailVoyage.vue?vue&type=template&id=ae8b2f08&"
import script from "./DetailVoyage.vue?vue&type=script&lang=js&"
export * from "./DetailVoyage.vue?vue&type=script&lang=js&"
import style0 from "./DetailVoyage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports